import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import FormInputTextField from '../FormInputTextField/FormInputTextField.vue'
import FormInputPhoneField from '../FormInputPhoneField/FormInputPhoneField.vue'
import FormInputEmailField from '../FormInputEmailField/FormInputEmailField.vue'
import FormCheckbox from '../FormCheckbox/FormCheckbox.vue'

export default {
    name: 'StafetProfileForm',
    components: {
        FormInputTextField,
        FormInputPhoneField,
        FormInputEmailField,
        FormCheckbox
    },
    props: {
        stafetId: {
            type: String,
            default: null
        },
        userData: {
            type: Object,
            default: {}
        },
        editProfileLink: {
            type: String,
            default: null
        },
        removeProfileLink: {
            type: String,
            default: null
        },
        editPasswordLink: {
            type: String,
            default: null
        }
    },
    setup(props) {
        const store = useStore()
        const mailSettingsBool = ref(props.userData.newsletter ?? false)
        const mailSettingsFighterNewsletterBool = ref(props.userData.fighterNewsletter ?? false)

        const labels = computed(() => {
            return store.state.labels.collections['SFLEditStafetLabels']
        })

        const setMailSettingBool = (value) => {
            mailSettingsBool.value = value
        }

        const setMailSettingFighterNewsletterBool = (value) => {
            mailSettingsFighterNewsletterBool.value = value
        }

        const saveChanges = () => {
            setTimeout(() => {
                store.dispatch('stafet/stafetProfileUpdatedSubmit', {
                    body: { 
                        mailSettingsBool: mailSettingsBool.value,
                        mailSettingsFighterNewsletterBool: mailSettingsFighterNewsletterBool.value, 
                    }
                })
            }, 300)
        }

        const openConfirmPageOverlay = function (e) {
            store.commit('main/set_page_overlay_content_data', {
                callback: () => {
                    store.dispatch('stafet/submitUpdateStafetProfile', {
                        userId: props.userData.userId,
                        body: {
                            sflNewsletter: mailSettingsBool.value,
                            fighterNewsletter: mailSettingsFighterNewsletterBool.value
                        }
                    })
                }
            })

            store.dispatch('main/openPageOverlay', {
                overlayContent: 'ConfirmChanges',
                returnTarget: e.currentTarget
            })
        }

        const openDeletePageOverlay = function (e) {
            store.commit('main/set_page_overlay_content_data', {
                callback: () => {
                    store.dispatch('stafet/submitDeleteStafetProfile', {
                        userId: props.userData.userId
                    })
                }
            })

            store.dispatch('main/openPageOverlay', {
                overlayContent: 'ConfirmDeleteProfile',
                returnTarget: e.currentTarget
            })
        }

        return {
            labels,
            mailSettingsBool,
            setMailSettingBool,
            mailSettingsFighterNewsletterBool,
            setMailSettingFighterNewsletterBool,
            saveChanges,
            openConfirmPageOverlay,
            openDeletePageOverlay
        }
    }
}
